import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { permanentRedirect } from '../helpers';
import { getSearchParams } from '../../helpers/urlUtility';

export default function UsersV2Redirect() {
  const navigate = useNavigate();
  const { pathname, search } = useLocation();
  const searchParams = getSearchParams(search);
  const redirect = permanentRedirect(navigate);

  useEffect(() => {
    const groupId = searchParams.get('groupId') || searchParams.get('groupid');

    if (pathname.endsWith('/groups/create')) {
      const parentId = searchParams.get('parentId') || searchParams.get('parentid');

      redirect(`/manage/groups/create${parentId ? `?parentId=${parentId}` : ''}`);
      return;
    }

    if (pathname.endsWith('/users/create')) {
      redirect(`/manage/users/create${groupId ? `?groupId=${groupId}` : ''}`);
      return;
    }

    if (groupId !== null) {
      redirect(`/manage/groups/${groupId}`);
      return;
    }

    if (pathname === '/users') {
      redirect('/manage/users');
      return;
    }

    if (pathname.includes('/users/groups/')) {
      const newPath = pathname.replace('/users/groups/', '/manage/groups/');
      redirect(newPath);
      return;
    }

    if (pathname.includes('/users/')) {
      const newPath = pathname.replace('/users/', '/manage/users/');
      redirect(newPath);
      return;
    }

    redirect('/error/404');
  }, [pathname, searchParams]);

  return null;
}
